'use client';
import CarouselPagination from 'components/shared/Carousel/CarouselPagination';

interface CarouselFooterProps {
  totalItems: number;
  current: number;
  className?: string;
  scrollTo: (index: number) => void;
  isTimed?: boolean;
  timeDuration?: number;
}

const CarouselFooter = ({ totalItems, current, scrollTo, className, isTimed, timeDuration }: CarouselFooterProps) => {
  return (
    <div className={className ? className : 'flex sm:justify-end'}>
      {totalItems > 1 && (
        <CarouselPagination
          total={totalItems}
          current={current}
          onSelect={scrollTo}
          isTimed={isTimed}
          timeDuration={timeDuration}
        />
      )}
    </div>
  );
};

export default CarouselFooter;
